"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoadingCount = getLoadingCount;
exports.isLoaded = isLoaded;
exports.isLoading = isLoading;
exports.getError = getError;
exports.hasError = hasError;

// TODO: We can make the thunks key consumer configurable by modifying these
// selectors
function getLoadingCount(state, id) {
  var requests = state.thunks.requests[id] || [];
  return requests.length;
}

function isLoaded(state, id) {
  var requests = state.thunks.requests[id] || [];
  return requests.length === 0;
}

function isLoading(state, id) {
  return !isLoaded(state, id);
}

function getError(state, id) {
  return state.thunks.errors[id];
}

function hasError(state, id) {
  return !!getError(state, id);
}